import { render, staticRenderFns } from "./CompareRow.vue?vue&type=template&id=3fe7119b"
import script from "./CompareRow.vue?vue&type=script&lang=ts"
export * from "./CompareRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports